import { useEffect, useState } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";
import NotifyDialog from "@/components/ateliers/NotifyDialog";
import CHero from "@/components/constellations/CHero";
import CIntroduction from "@/components/constellations/CIntroduction";
import CHowItWorks from "@/components/constellations/CHowItWorks";
import CRoles from "@/components/constellations/CRoles";
import CBenefits from "@/components/constellations/CBenefits";
import CPracticalInfo from "@/components/constellations/CPracticalInfo";
import CFinalCTA from "@/components/constellations/CFinalCTA";

export default function ConstellationsPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [notifyOpen, setNotifyOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]" data-testid="constellations-page">
      <Navbar onBookingClick={() => setBookingOpen(true)} />
      <main>
        <CHero />
        <CIntroduction />
        <CHowItWorks />
        <CRoles />
        <CBenefits />
        <CPracticalInfo />
        <CFinalCTA onNotify={() => setNotifyOpen(true)} />
      </main>
      <Footer />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
      <NotifyDialog open={notifyOpen} onOpenChange={setNotifyOpen} />
    </div>
  );
}
